<template lang="pug">
  div(
    v-if="consumptions"
    class="billing-usage-progress"
  )
    v-progress-linear(
      background-color="#ffffff"
      :color="hasReachedLimit ? '#FF1744' : '#8F257D'"
      rounded
      height="10"
      :value="usedDocumentsPercentage"
    )
    div(class="text-12px fw-300 py-2") {{ $t('Used count of documents', { used: consumptions.used, limit: consumptions.limit }) }}
    v-btn(
      class="outlined-button w-100"
      @click="goToBillingPage"
    ) {{ $t('Increase limit') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BillingUsageProgress',
  computed: {
    ...mapGetters('billing', {
      consumptions: 'consumptions'
    }),
    usedDocuments() {
      return this._.get(this.consumptions, 'used')
    },
    limit() {
      return this._.get(this.consumptions, 'limit')
    },
    usedDocumentsPercentage() {
      return Math.round((this.usedDocuments / this.limit) * 100)
    },
    hasReachedLimit() {
      const remaining = this.limit - this.usedDocuments
      const remainingPercent = (remaining / this.limit) * 100
      return remainingPercent <= 10
    }
  },
  methods: {
    goToBillingPage() {
      if (this.$route.name === 'billing') {
        this.$store.commit('billing/SET_CHANGE_TAB_INDEX', 0)
      } else {
        this.$router.push('/billing')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.billing-usage-progress {
  border-radius: 12px;
  border: 1px solid $white;
  background: url('~/assets/images/billing-progress-bg.png') lightgray 50% / cover no-repeat;
  padding: 12px;
}
</style>
